import { render, staticRenderFns } from "./ForgotPasswordConfirm.vue?vue&type=template&id=d445ee56"
import script from "./ForgotPasswordConfirm.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d445ee56')) {
      api.createRecord('d445ee56', component.options)
    } else {
      api.reload('d445ee56', component.options)
    }
    module.hot.accept("./ForgotPasswordConfirm.vue?vue&type=template&id=d445ee56", function () {
      api.rerender('d445ee56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgotPasswordConfirm.vue"
export default component.exports